module.exports = __webpack_public_path__ + "img/Pdf-file.da4ce1ab.svg";